<section class="donors" [attr.data-expanded]="description">
    <h2>Parceiros Institucionais</h2>

    <div class="partners-grid" aria-label="Parceiros do Dia de Doar">

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/1-BeTheEarth.png" alt="Be The Earth Foundation"
                loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/2-Benera.png" alt="Benera" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/3-Doare.png" alt="Doare" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/4-Idis.png" alt="IDIS" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/5-InstitutoBeja.png" alt="Instituto Beja" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/6-Infinis.png" alt="Infinis" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/7-acp.png" alt="Instituto ACP" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/8-Plan.png" alt="Plan International" loading="lazy">
        </div>

        <div class="partner-logo">
            <img src="assets/logo-parceiros-institucionais/9-RDsaude.png" alt="RD Saúde" loading="lazy">
        </div>

    </div>

    <a class="support-link" href="mailto:contato@diadedoar.org.br
     ?subject=Quero%20apoiar%20o%20Dia%20de%20Doar
     &body=Olá,%20equipe%20Dia%20de%20Doar.%20Gostaria%20de%20apoiar%20o%20movimento.%20Podem%20me%20orientar?">
        Quer doar e apoiar a ampliação do Dia de Doar?
    </a>

    <footer>
        <p>
            O Dia de Doar não intermedeia as doações captadas pelas instituições
            participantes do movimento. Ou seja, nós não distribuímos recursos
            financeiros captados. Anualmente lançamos o Edital de Apoio à Filantropia
            Comunitária que seleciona coletivos e ativistas pela cultura de doação.
        </p>

        <div *ngIf="description">
            <h3>Quer doar e apoiar a ampliação do Dia de Doar?</h3>
            <p>
                Nossos parceiros são pessoas físicas, empresas e organizações que
                ajudam a financiar este grande movimento nacional e executar
                estratégias para fortalecimento da cultura de doação no Brasil.
            </p>
            <p>
                Seja com doação direta de recursos ou prestando serviços que nos
                permitam alavancar a campanha nacionalmente, se sua empresa ou
                organização quer ser parceira do Dia de Doar, escreva para
                <a href="mailto:contato@diadedoar.org.br">contato&commat;diadedoar.org.br</a>.
            </p>
        </div>
    </footer>
</section>